import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
export const fetchEventDefinitionDetails = async (eventDefinitionId) => fetch("GET", qualifyUrl(`/events/definitions/${eventDefinitionId}`));
const useEventDefinition = (eventDefId, enabled = true) => {
  const { data, isFetching, isInitialLoading } = useQuery({
    queryKey: ["get-event-definition-details", eventDefId],
    queryFn: () => defaultOnError(fetchEventDefinitionDetails(eventDefId), "Loading archives failed with status"),
    retry: 0,
    placeholderData: keepPreviousData,
    enabled: !!eventDefId && enabled
  });
  return { data, isFetching, isInitialLoading };
};
export default useEventDefinition;
